import {Component, inject, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { RoleService } from "../../../data-access/role.service";
import {faTriangleExclamation, faXmark, faPlus, faGear} from "@fortawesome/free-solid-svg-icons";
import * as Papa from 'papaparse'
import {RoleTempInterface} from "../../../../dashboard/userProfile/userProfile.component";
import {SubjectsModel} from "../../../data-access/subjects.model";
import {UnitsModel} from "../../../data-access/units.model";
import {User} from "../../../data-access/user.model";
import {RoleModel} from "../../../data-access/role.model";
import {UserManagementService} from "../../../data-access/user-management.service";
import {ComponentCanDeactivate} from "../../../../exam/utils/pending-changes.guard";
import {Observable, of, switchMap} from "rxjs";
import {
  ConfirmDialogComponent,
  DIALOG_ACTION_STYLE
} from "../../../../shared/ui/confirm-dialog/confirm-dialog.component";
import {Dialog} from "@angular/cdk/dialog";
import {FormControl, FormGroup} from "@angular/forms";
import {Location} from "@angular/common";
import {MatSnackBar} from "@angular/material/snack-bar";
import {OrganizationsModel} from "../../../data-access/organizations.model";
import {Course} from "../../../data-access/course.model";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";

interface Person {
  name: string
  netID: string
  email: string
}
export interface RoleBulkImport {
  role_id: string,
  organization_id?: string | null,
  subject_id?: string | null,
  unit_id?: string | null,
  course_id?: string | null
}
interface ImportResult {
  allnew: number
  justroles: number
  nochange: number
  nouname: number
  noemail: number
  errors: number
  badroles: number
}
@Component({
    selector: 'importUsers',
    templateUrl: './importUsers.html',
    styleUrls: ['importUsers.css'],
    standalone: false
})
export class ImportUsersComponent implements ComponentCanDeactivate, OnInit {
  data: Person[] = []
  dataToBeSubmitted: User[] = []
  roleToBeSubmitted: RoleBulkImport[] = []
  faTriangleExclamation = faTriangleExclamation
  faXmark = faXmark
  faGear = faGear
  faPlus = faPlus
  openExitDialog = false
  sampleFileOpen = false
  openAddRoleDialog = false
  roles: RoleTempInterface[] = []
  addedUserRoles: RoleTempInterface[] = []
  addedTempUserRole: RoleTempInterface[] = []
  subjectList: SubjectsModel[] = [];
  addedSubjectList: SubjectsModel[] = [];
  addedOrgList: OrganizationsModel[] = []
  addedCourseList: Course[] = []
  unitList: UnitsModel[] = [];
  addedUnitList: UnitsModel[] = [];
  roleValidation = false;
  userValidation = false;
  successImportDialog = false;
  successImportResponse: ImportResult | null = null
  userFieldsValidationError: boolean = false;
  submitClick = false
  dialog = inject(Dialog);
  importForm = new FormGroup({
    csv: new FormControl(null),
  })
  _location = inject(Location)
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'User Management',
    route: 'dashboard/UserManagement'
  }]

  constructor(
    private router: Router,
    private roleService: RoleService,
    private userService: UserManagementService,
    private _snackBar: MatSnackBar
  ) {
  }
  ngOnInit() {
    this.roleService.listAllUserRoles().subscribe((response) => {
      if(response.success)
        this.roles = response.items
    })
  }

  userManagementMenu() {
    this.router.navigate(['dashboard/UserManagement']);
  }

  onChange(event: any) {
   Papa.parse(event.target.files[0], {
     header: true,
     skipEmptyLines: true,
     complete: (result: any, file: any) => {
       this.data = result.data
     }
   })
  }

  removeItemFromList(item: any, list: any[]) {
    return list.filter(e => JSON.stringify(e) !== JSON.stringify(item));
  }

  exitImport() {
    this.router.navigate(['dashboard/UserManagement'])
  }

  submit() {
    if(this.addedUserRoles.length === 0)
      this.roleValidation = true
    else {
      this.submitClick = true
      this.roleValidation = false
      this.roleToBeSubmitted = []
      this.addedUserRoles.forEach((role) => {
        this.roleToBeSubmitted.push({
          role_id: role.role_id,
          organization_id: role.organizations != undefined? role.organizations[0].organization_id: null,
          subject_id: role.subjects != undefined? role.subjects[0].subject_id: null,
          unit_id: role.units != undefined? role.units[0].unit_id: null,
          course_id: role.courses != undefined? role.courses[0].course_id.toString(): null
        })
      })
    }

    if(this.data.length === 0)
      this.userValidation = true
    else {
      const fieldIsEmpty = this.data.filter((item) =>
        item.email == '' ||
        item.name == '' ||
        item.netID == ''
      );
      if(fieldIsEmpty.length) {
        this.successImportDialog = true;
        this.userFieldsValidationError = true;
      }
      else {
        this.userValidation = false
        this.dataToBeSubmitted = []
        this.data.forEach((person) => {
          this.dataToBeSubmitted.push({
            email: person.email,
            username: person.netID,
            display_name: person.name,
            active: true
          })
        })
        if(!this.roleValidation && !this.userValidation) {
          this.userService.createBulkUsers(this.dataToBeSubmitted, this.roleToBeSubmitted).subscribe((response) => {
            if(response.success) {
              this.successImportDialog = true;
              this.successImportResponse = response.result
            } else {
              this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
            }
          })
        }
      }
    }
    // TODO need to respond to the user with the response results
  }

  saveNewRole(role: RoleTempInterface[]) {
    const role_name = this.roles.find(r => r.role_id === role[0].role_id)?.name
    if(role.length > 0) {
      this.addedUserRoles = this.addedUserRoles.filter(e => JSON.stringify(e) !== JSON.stringify({name: role_name, role_id: role[0].role_id, subjects: this.addedSubjectList, units: this.addedUnitList, organizations: this.addedOrgList, courses: this.addedCourseList}));
      this.addedUserRoles.push({name: role_name != undefined? role_name: '', role_id: role[0].role_id, subjects: this.addedSubjectList, units: this.addedUnitList, organizations: this.addedOrgList, courses: this.addedCourseList})
    }
    this.addedTempUserRole = []
    this.addedSubjectList = []
    this.addedUnitList = []
    this.addedOrgList = []
    this.addedCourseList = []
    this.openAddRoleDialog = false;
  }

  autoImportNavigate() {
    this.router.navigate(['dashboard/UserManagement/AllUsers/ImportUsers/AutomaticImportList'])
  }

  canDeactivate(): Observable<boolean> {
    if (this.importForm.dirty && !this.submitClick) {
      const dialogRef = this.dialog.open<string>(ConfirmDialogComponent, {
        data: {
          title: 'Sure you want to cancel?',
          message: 'Are you sure you want to cancel the import?',
          button_actions: [
            {
              label: 'Yes, Cancel',
              style: DIALOG_ACTION_STYLE.PRIMARY,
              action: () => 'Confirm',
            },
            {
              label: "Don't Cancel",
              style: DIALOG_ACTION_STYLE.DEFAULT,
              action: () => 'Cancel',
            },
          ],
        },
      });

      return dialogRef.closed.pipe(
        switchMap((result) => {
          if (result === 'Confirm') {
            return of(true);
          }
          return of(false);
        })
      );
    }
    return of(true)
  }
}
